import { Component, inject, Renderer2 } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { CardModule } from 'primeng/card';
import { usePreset } from '@primeuix/themes';
import SpringPreset from '../shared/themes/spring.preset';
import VividPreset from '../shared/themes/vivid.preset';
import { KeyboardService } from '../core/services';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, CardModule, ButtonModule, ButtonGroupModule],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class FarachatLayoutComponent {
  private keyboardService = inject(KeyboardService);
  private renderer = inject(Renderer2);

  setSprintTheme() {
    usePreset(SpringPreset);
    const element = document.querySelector('html');
    element.classList.remove('vivid-theme');
    element.classList.add('sprint-theme');
  }

  setVividTheme() {
    usePreset(VividPreset);
    const element = document.querySelector('html');
    element.classList.remove('sprint-theme');
    element.classList.add('vivid-theme');
  }
}
